import React, { useState } from "react";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import {
  ButtonMain,
  DateConvertor,
  FullTable,
  FullTableAccordionMain,
  PriceConvertor,
  ReadMore,
  SearchInput,
  ShareBtn,
  TextToolTip,
} from "components";
import { SortDrawer } from "fragments";
import { CharityDetails } from "./charityDetails";
import { fundraiserStatuses } from "../../fundraisers";
import { ProfileInfo, useModal, useWindowDimensions } from "utils";
import { Images, Svg } from "assets";
import { CHARITY_TABLE_ACTION_TYPE } from "../../charities/fragments";
import {
  contributionsAccordionDetails,
  contributionsBody,
  contributionsHead,
} from "./constants";
import { ContributionCard } from "./contributionCard";
import { SortContentDrawer } from "./sortContentDrawer";

export const EventInfo = () => {
  const [showMoreCharities, setShowMoreCharities] = useState(false);
  const { fundraiserById, donationFundraiser } = useSelector((state) => ({
    fundraiserById: state.fundraiser.fundraiserById,
    donationFundraiser: state.donation.donationFundraiser,
  }));

  const navigate = useNavigate();
  const { openModal } = useModal();
  const { width } = useWindowDimensions();
  const { ifCharity } = ProfileInfo();
  const isMemory = fundraiserById?.type === "MEMORY";

  const showCharity = fundraiserById?.charities?.length
    ? fundraiserById?.charities.slice(0, 2)
    : [];

  const showedAnotherCharity = fundraiserById?.charities?.length
    ? fundraiserById?.charities.slice(2)
    : [];

  return (
    <>
      <div className="event-details-info-box-desktop">
        <div className="event-details-info-box">
          <div className="event-details_img-charities">
            <div className="event-details-image">
              {/*<p*/}
              {/*  className="event-details-info-type"*/}
              {/*  style={{ background: isMemory ? "#E0E1E2" : "" }}*/}
              {/*>*/}
              {/*  {isMemory ? "In Memory of" : "In Celebration"}*/}
              {/*</p>*/}
              {fundraiserById?.images?.length ? (
                <Swiper
                  className="event-details-image-slide"
                  modules={[Pagination]}
                  pagination={{ clickable: true }}
                >
                  {fundraiserById?.images?.map((image, index) => (
                    <SwiperSlide key={index}>
                      <img
                        src={image?.url}
                        alt={`Slide ${index + 1}`}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "contain",
                          background: "#D9D9D9",
                        }}
                      />
                    </SwiperSlide>
                  ))}
                </Swiper>
              ) : (
                <img
                  src={
                    isMemory ? Images.needCardFrame : Images.needCardFrameWhite
                  }
                  alt="compaign"
                />
              )}
            </div>

            <p className="created-by-text">
              <span style={{ fontWeight: 700 }}>Created by: </span>
              {fundraiserById?.owner?.firstName &&
                fundraiserById?.owner?.lastName &&
                `${fundraiserById?.owner?.firstName} ${fundraiserById?.owner?.lastName}`}{" "}
              on {DateConvertor(fundraiserById?.createdAt)}
            </p>

            <div className="description-wrapper">
              <h3 className="description-title">Description</h3>

              {fundraiserById?.description && (
                <ReadMore maxLength={430} text={fundraiserById?.description} />
              )}
            </div>
          </div>

          <div className="event-details_info-organizer">
            <div className="event-details-info-section">
              <div className="event-details-info_type-displayId">
                {fundraiserById?.status === fundraiserStatuses.LIVE ? (
                  <div
                    className={`event-details-info_type ${
                      isMemory ? "event-details-info_type-memory" : ""
                    }`}
                  >
                    <div className="event-details-info_type-circle" />
                    Active
                  </div>
                ) : (
                  <p
                    className="event-details-info-displayId"
                    style={{ background: isMemory ? "#E0E1E2" : "" }}
                  >
                    Past
                  </p>
                )}

                {fundraiserById?.displayId && (
                  <p
                    className="event-details-info-displayId"
                    style={{ background: isMemory ? "#E0E1E2" : "" }}
                  >
                    Event ID: {fundraiserById?.displayId}
                  </p>
                )}
              </div>

              <p className="event-details-price">
                Total Contributions:{" "}
                {PriceConvertor({ price: fundraiserById?.balance })}
              </p>

              <div className="event-details-info_date">
                <div className="event-details-names-block">
                  {fundraiserById?.firstName && (
                    <p className="event-details-firstName">
                      {fundraiserById?.firstName}{" "}
                    </p>
                  )}
                  {fundraiserById?.lastName && (
                    <p className="event-details-firstName">
                      {fundraiserById?.lastName}{" "}
                    </p>
                  )}
                  {fundraiserById?.middleName && (
                    <p className="event-details-firstName">
                      {fundraiserById?.middleName}{" "}
                    </p>
                  )}
                </div>

                {fundraiserById?.type && (
                  <p className="date-off-celebration">
                    Type:{" "}
                    <span className="date-off-celebration-date">
                      {fundraiserById?.type === "MEMORY"
                        ? "In Memory of"
                        : "In Celebration"}
                    </span>
                  </p>
                )}

                {fundraiserById?.celebrationDate && (
                  <p className="date-off-celebration">
                    Date of Celebration:{" "}
                    <span className="date-off-celebration-date">
                      {DateConvertor(fundraiserById?.celebrationDate)}
                    </span>
                  </p>
                )}

                {fundraiserById?.birthDate && (
                  <p className="date-off-celebration">
                    Date of Birth:{" "}
                    <span className="date-off-celebration-date">
                      {DateConvertor(fundraiserById?.birthDate)}
                    </span>
                  </p>
                )}

                {fundraiserById?.deathDate && (
                  <p className="date-off-celebration">
                    Date of Death:{" "}
                    <span className="date-off-celebration-date">
                      {DateConvertor(fundraiserById?.deathDate)}
                    </span>
                  </p>
                )}

                {fundraiserById?.endDate && (
                  <p className="date-off-celebration">
                    End Date:{" "}
                    <span className="date-off-celebration-date">
                      {DateConvertor(fundraiserById?.endDate)}
                    </span>
                  </p>
                )}
              </div>

              <div className="event-details-donate-and-share">
                {fundraiserById?.status === fundraiserStatuses.LIVE &&
                  !ifCharity && (
                    <ButtonMain
                      classNameWrapper={`event-details-donate-btn ${
                        isMemory ? "event-details-donate-btn-memory" : ""
                      }`}
                      startIcon={<Svg.HeartSvg />}
                      text="Donate now"
                      type="button"
                      onClick={() => navigate(`/donate/${fundraiserById?.id}`)}
                    />
                  )}

                <ShareBtn
                  buttonText="Share"
                  background="transparent"
                  border="1px solid #E0E1E2"
                  fundraiserById={fundraiserById}
                />
              </div>

              {!!showCharity?.length && (
                <div className="event-details-charities-wrapper">
                  <h3 className="event-details-charities-title">Charities</h3>
                  <div>
                    {!!showCharity.length && (
                      <div className="event-details-charities-box">
                        {showCharity?.map((item, index) => (
                          <button
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              openModal(<CharityDetails charity={item} />, {
                                padding: "noPaddings",
                                noShowCloseBrn: true,
                              });
                            }}
                            type={"button"}
                            className="event-details-charity"
                            key={index}
                          >
                            <div className="event-details-charities_svg">
                              {isMemory ? (
                                <Svg.FundraiserFrameMemorySvg />
                              ) : (
                                <Svg.FundraiserFrameSvg />
                              )}
                            </div>

                            <p>{item?.charity?.name}</p>
                          </button>
                        ))}
                      </div>
                    )}

                    {!!showedAnotherCharity.length && (
                      <div>
                        {showMoreCharities && (
                          <div
                            className="event-details-charities-box"
                            style={{ marginTop: "4px" }}
                          >
                            {showedAnotherCharity?.map((item, index) => (
                              <button
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  openModal(<CharityDetails charity={item} />, {
                                    padding: "noPaddings",
                                    noShowCloseBrn: true,
                                  });
                                }}
                                type={"button"}
                                className="event-details-charity"
                                key={index}
                              >
                                <div className="event-details-charities_svg">
                                  {isMemory ? (
                                    <Svg.FundraiserFrameMemorySvg />
                                  ) : (
                                    <Svg.FundraiserFrameSvg />
                                  )}
                                </div>

                                <p>{item?.charity?.name}</p>
                              </button>
                            ))}
                          </div>
                        )}

                        <button
                          onClick={() =>
                            setShowMoreCharities((prevState) => !prevState)
                          }
                          className="event-details-charities_see-button"
                        >
                          {showMoreCharities
                            ? "Hide More Charities"
                            : "See More Charities"}
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        {!!donationFundraiser?.donations?.length && (
          <div className="contributions-wrapper">
            <h2 className="contributions-title">Contributions</h2>

            <FullTable
              classNameWrapper="contributions-full-table"
              head={contributionsHead(width)}
              body={contributionsBody(width)}
              loadingType={CHARITY_TABLE_ACTION_TYPE}
              list={donationFundraiser?.donations}
            />
          </div>
        )}
      </div>

      <div className="event-details-info-box-mobile">
        <div className="event-details-info-box">
          {fundraiserById?.name && (
            <TextToolTip
              classNameText={"event-details-info-name"}
              text={fundraiserById?.name}
              content={fundraiserById?.name}
            />
          )}

          <div className="event-details-image">
            {/*<p*/}
            {/*  className="event-details-info-type"*/}
            {/*  style={{ background: isMemory ? "#E0E1E2" : "" }}*/}
            {/*>*/}
            {/*  {isMemory ? "In Memory of" : "In Celebration"}*/}
            {/*</p>*/}

            {fundraiserById?.images?.length ? (
              <Swiper
                className="event-details-image-slide"
                modules={[Pagination]}
                pagination={{ clickable: true }}
              >
                {fundraiserById?.images?.map((image, index) => (
                  <SwiperSlide key={index}>
                    <img
                      src={image?.url}
                      alt={`Slide ${index + 1}`}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                        background: "#D9D9D9",
                      }}
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
            ) : (
              <img
                src={
                  isMemory ? Images.needCardFrame : Images.needCardFrameWhite
                }
                alt="compaign"
              />
            )}
          </div>

          <p className="created-by-text">
            <span style={{ fontWeight: 700 }}>Created by: </span>
            {fundraiserById?.owner?.firstName &&
              fundraiserById?.owner?.lastName &&
              `${fundraiserById?.owner?.firstName} ${fundraiserById?.owner?.lastName}`}{" "}
            on {DateConvertor(fundraiserById?.createdAt)}
          </p>

          <div className="event-details-info-section">
            <div className="event-details-info_type-displayId">
              {fundraiserById?.status === fundraiserStatuses.LIVE ? (
                <div
                  className={`event-details-info_type ${
                    isMemory ? "event-details-info_type-memory" : ""
                  }`}
                >
                  <div className="event-details-info_type-circle" />
                  Active
                </div>
              ) : (
                <p
                  className="event-details-info-displayId"
                  style={{ background: isMemory ? "#E0E1E2" : "" }}
                >
                  Past
                </p>
              )}

              {fundraiserById?.displayId && (
                <p
                  className="event-details-info-displayId"
                  style={{ background: isMemory ? "#E0E1E2" : "" }}
                >
                  Event ID: {fundraiserById?.displayId}
                </p>
              )}
            </div>

            <p className="event-details-price">
              Total Contributions:{" "}
              {PriceConvertor({ price: fundraiserById?.balance })}
            </p>

            <div className="event-details-info_date">
              <div className="event-details-names-block">
                {fundraiserById?.firstName && (
                  <p className="event-details-firstName">
                    {fundraiserById?.firstName}{" "}
                  </p>
                )}
                {fundraiserById?.lastName && (
                  <p className="event-details-firstName">
                    {fundraiserById?.lastName}{" "}
                  </p>
                )}
                {fundraiserById?.middleName && (
                  <p className="event-details-firstName">
                    {fundraiserById?.middleName}{" "}
                  </p>
                )}
              </div>

              {fundraiserById?.type && (
                <p className="date-off-celebration">
                  Type:{" "}
                  <span className="date-off-celebration-date">
                    {fundraiserById?.type === "MEMORY"
                      ? "In Memory of"
                      : "In Celebration"}
                  </span>
                </p>
              )}

              {fundraiserById?.celebrationDate && (
                <p className="date-off-celebration">
                  Date of Celebration:{" "}
                  <span className="date-off-celebration-date">
                    {DateConvertor(fundraiserById?.celebrationDate)}
                  </span>
                </p>
              )}

              {fundraiserById?.birthDate && (
                <p className="date-off-celebration">
                  Date of Birth:{" "}
                  <span className="date-off-celebration-date">
                    {DateConvertor(fundraiserById?.birthDate)}
                  </span>
                </p>
              )}

              {fundraiserById?.deathDate && (
                <p className="date-off-celebration">
                  Date of Death:{" "}
                  <span className="date-off-celebration-date">
                    {DateConvertor(fundraiserById?.deathDate)}
                  </span>
                </p>
              )}

              {fundraiserById?.endDate && (
                <p className="date-off-celebration">
                  End Date:{" "}
                  <span className="date-off-celebration-date">
                    {DateConvertor(fundraiserById?.endDate)}
                  </span>
                </p>
              )}
            </div>

            <div className="event-details-donate-and-share">
              {fundraiserById?.status === fundraiserStatuses.LIVE &&
                !ifCharity && (
                  <ButtonMain
                    classNameWrapper={`event-details-donate-btn ${
                      isMemory ? "event-details-donate-btn-memory" : ""
                    }`}
                    startIcon={<Svg.HeartSvg />}
                    text="Donate now"
                    type="button"
                    onClick={() => navigate(`/donate/${fundraiserById?.id}`)}
                  />
                )}
              <ShareBtn
                buttonText="Share"
                background="transparent"
                border="1px solid #E0E1E2"
                fundraiserById={fundraiserById}
              />
            </div>

            {!!showCharity?.length && (
              <div className="event-details-charities-wrapper">
                <h3 className="event-details-charities-title">Charities</h3>
                <div>
                  {!!showCharity.length && (
                    <div className="event-details-charities-box">
                      {showCharity?.map((item, index) => (
                        <button
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            openModal(<CharityDetails charity={item} />, {
                              padding: "noPaddings",
                              noShowCloseBrn: true,
                            });
                          }}
                          type={"button"}
                          className="event-details-charity"
                          key={index}
                        >
                          <div className="event-details-charities_svg">
                            {isMemory ? (
                              <Svg.FundraiserFrameMemorySvg />
                            ) : (
                              <Svg.FundraiserFrameSvg />
                            )}
                          </div>

                          <p>{item?.charity?.name}</p>
                        </button>
                      ))}
                    </div>
                  )}

                  {!!showedAnotherCharity.length && (
                    <div>
                      {showMoreCharities && (
                        <div
                          className="event-details-charities-box"
                          style={{ marginTop: "4px" }}
                        >
                          {showedAnotherCharity?.map((item, index) => (
                            <button
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                openModal(<CharityDetails charity={item} />, {
                                  padding: "noPaddings",
                                  noShowCloseBrn: true,
                                });
                              }}
                              type={"button"}
                              className="event-details-charity"
                              key={index}
                            >
                              <div className="event-details-charities_svg">
                                {isMemory ? (
                                  <Svg.FundraiserFrameMemorySvg />
                                ) : (
                                  <Svg.FundraiserFrameSvg />
                                )}
                              </div>

                              <p>{item?.charity?.name}</p>
                            </button>
                          ))}
                        </div>
                      )}

                      <button
                        onClick={() =>
                          setShowMoreCharities((prevState) => !prevState)
                        }
                        className="event-details-charities_see-button"
                      >
                        {showMoreCharities
                          ? "Hide More Charities"
                          : "See More Charities"}
                      </button>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>

          <div className="description-wrapper">
            <h3 className="description-title">Description</h3>

            {fundraiserById?.description && (
              <ReadMore maxLength={430} text={fundraiserById?.description} />
            )}
          </div>

          <div className="contributions-wrapper">
            <h2 className="contributions-title">Contributions</h2>
            {width < 768 && (
              <div
                className="flex-all-center"
                style={{ gap: 16, marginBottom: 16 }}
              >
                <SearchInput
                  placeholder={"Search..."}
                  searchKey={"donorName"}
                  className="contributions-search-input"
                />

                <SortDrawer ContentDrawer={SortContentDrawer} />
              </div>
            )}

            {!!donationFundraiser?.donations?.length && (
              <>
                {width > 767 ? (
                  <FullTableAccordionMain
                    classNameWrapper="contributions-accordion"
                    head={contributionsHead(width)}
                    body={contributionsBody(width)}
                    accordionDetails={contributionsAccordionDetails}
                    list={donationFundraiser?.donations}
                  />
                ) : (
                  <>
                    <div className="contribution-cards-block">
                      {donationFundraiser?.donations.map((item, index) => (
                        <ContributionCard item={item} key={index} />
                      ))}
                    </div>
                  </>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
